/**
 * /people/org-design-agent — Tashghil's org design surface +
 * Mutaba'aa's Saudization drift dashboard (Pack 4 v2 UI).
 */

import { PageHeader } from "../components/ui";
import { AgentBadge } from "../components/ui/AgentBadge";

export function OrgDesignAgentPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Org Design Agent"
        subtitle="Tashghil drives re-org workflows; Mutaba'aa watches Saudization tier + sector reservation drift continuously."
      />

      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3">
          <AgentBadge agent="tashghil" />
          <h3 className="text-base font-semibold">Re-org workflows</h3>
        </div>
        <ul className="text-sm text-text-secondary space-y-1.5">
          <li><strong>Department rename / merge / split</strong> — Tashghil orchestrates; Mutaba'aa veto on Article 18 succession.</li>
          <li><strong>Position move</strong> — Tashghil routes approvals; Rawatib re-bases payroll if pay band changes.</li>
          <li><strong>Reporting change</strong> — Tashghil writes new position_reports_to row with cycle check.</li>
          <li><strong>Legal entity transfer</strong> — Mutaba'aa enforces Article 18 tenure continuity + Pack 10 GOSI re-registration.</li>
        </ul>
      </section>

      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3">
          <AgentBadge agent="mutabaa" />
          <h3 className="text-base font-semibold">
            Sector reservation drift (Saqaha 2021)
          </h3>
        </div>
        <p className="text-sm text-text-secondary">
          Mutaba'aa's <code>sector_reservation_drift_saqaha</code> scan
          runs every Sunday 03:00 KSA per the Pack 1 F.4 scheduler. When
          a tenant's Saudi percentage drifts below the Nitaqat tier
          floor, Mutaba'aa fires a TENANT_STATUTORY_FLOOR_FAILURE event
          with severity per drift magnitude.
        </p>
      </section>
    </div>
  );
}
